import * as EventFactory from 'OK/EventFactory';
import throttle from 'OK/utils/throttle';

type GwtEventBusCallbackType = (eventName: string, data: object) => void;

let instance: DispatcherJs | null = null;
let gwtEventBusCallback: GwtEventBusCallbackType | null = null;
let REPEAT_TIMEOUT = 51;

function isWideLayout() {
    var layoutContainer = document.querySelector('.layout-container');

    if (layoutContainer && layoutContainer.classList.contains('__wide-right-column')) {
        return window.matchMedia("screen and (min-width: 1350px)").matches;
    } else {
        return window.matchMedia("screen and (min-width: 1274px)").matches;
    }
}

let wasWide = isWideLayout();

let onResize = throttle(
    REPEAT_TIMEOUT,
    () => {
        const isWide = isWideLayout();
        if (isWide !== wasWide) {
            wasWide = isWide;
            DispatcherJs.handleGwtEvent('ForthColumnToggledEvent', {
                visible: isWide
            });
        }
    },
    false
);

window.addEventListener('resize', onResize, false);

export class DispatcherJs {
    bannerViewStateChangedEvent: EventFactory.OkEvent;
    updateEvent: EventFactory.OkEvent;
    forthColumnToggledEvent: EventFactory.OkEvent;
    stateChangeEvent: EventFactory.OkEvent;
    dataLoadedEvent: EventFactory.OkEvent;

    constructor() {
        this.bannerViewStateChangedEvent = EventFactory.create();
        this.updateEvent = EventFactory.create();
        this.forthColumnToggledEvent = EventFactory.create();
        this.stateChangeEvent = EventFactory.create();
        this.dataLoadedEvent = EventFactory.create();
    }

    static get(): DispatcherJs {
        if (instance === null) {
            instance = new DispatcherJs();
        }
        return instance;
    }

    static publish(eventName: string, data: Record<string, unknown>) {
        switch (eventName) {
            case 'ForthColumnToggledEvent':
                DispatcherJs.get().forthColumnToggledEvent.trigger(data.visible as object);
                break;
            case 'DataLoadedEvent':
                DispatcherJs.get().dataLoadedEvent.trigger(data);
                break;
            case 'stateChangeEvent':
                DispatcherJs.get().stateChangeEvent.trigger(data);
                break;
            default:
        }
    }

    static registerGwtEventBus(callback: GwtEventBusCallbackType) {
        gwtEventBusCallback = callback;
    }

    static handleGwtEvent(eventName: string, data: object) {
        if (gwtEventBusCallback) {
            gwtEventBusCallback(eventName, data);
        }
    }

    static isWideLayout = isWideLayout;
}
